export function getPageUrl() {
  let pageUrl = window.location.href.split('#')[0];
  const origReferrer = window.location.href.split('orig_referrer=');
  if (origReferrer.length > 1) {
    // eslint-disable-next-line prefer-destructuring
    pageUrl = origReferrer[0];
  }
  return pageUrl;
}

export function getReferrer() {
  let { referrer } = document;
  const origReferrer = window.location.href.split('orig_referrer=');
  if (origReferrer.length > 1) {
    referrer = decodeURIComponent(origReferrer[1].split('&')[0]);
  }
  return referrer;
}

export function getEtUid() {
  const etUid = window.location.href.split('et_user_id=');
  if (etUid.length > 1) {
    return decodeURIComponent(etUid[1].split('&')[0]);
  }
  return null;
}
